export const formatHubGptApiMessage = ({
  message,
  threadId
}) => {
  const transformedMessage = {
    message: '',
    created_at: message.createdAt,
    displayType: 'SECTIONS',
    query: {
      intent: 'unknown',
      reason: ''
    },
    data_table: null,
    image_grid: null,
    actions: [],
    suggestions: null,
    credits: null,
    elapsed_time: null,
    error: null,
    card_type: null,
    sections: [{
      id: message.id,
      text: message.content,
      type: 'MARKDOWN'
    }],
    error_detail: null,
    source: 'CHAT',
    response: '',
    api_requests: null,
    response_key: null,
    user_tried_memory: null,
    should_poll_for_thread_metadata: false,
    typed_output: null,
    token: message.id,
    user_token: '1143953',
    thread_id: threadId || null,
    id: message.id,
    role: message.role === 'assistant' ? 'CHATSPOT' : 'USER',
    from_sem_rush: false,
    type: message.role === 'assistant' ? 'chatspot' : 'user'
  };
  return transformedMessage;
};
export const formatHubGptApiMessages = ({
  messages
}) => {
  const assistantMessage = messages.find(message => message.role === 'assistant');
  if (!assistantMessage) {
    return [];
  }
  const transformedMessages = formatHubGptApiMessage({
    message: assistantMessage
  });
  return transformedMessages;
};